import API from '../';
import { HTTP_METHODS } from '../helpers/methods-helpers';

class OrganAPI extends API {
	getByModulesByOrgan(organ) {
		return this.requestWrapper(
			this.request({
				url: `${this.scheme}/${organ}`,
				method: HTTP_METHODS.post_M,
			})
		);
	}

	getOrgansByStatus(status) {
		return this.requestWrapper(
			this.request({
				url: `${this.scheme}/get?estatus=${status}`,
				method: HTTP_METHODS.post_M,
			})
		);
	}
}

export const organsAPI = new OrganAPI('/organos');
